import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineHeight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLineHeight"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V6H2V4ZM12 6.58579L15.4142 10L14 11.4142L12 9.41421L10 11.4142L8.58579 10L12 6.58579ZM10 12.5858L12 14.5858L14 12.5858L15.4142 14L12 17.4142L8.58579 14L10 12.5858ZM2 18H22V20H2V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineHeight;
